import { Button, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import PasscodeInput from "../../../../../components/passcodeInput/PasscodeInput"
import useMultiInputFocus from "../../../../../hooks/useMultiInputFocus"
import { useUserQuery } from "../../../../../networking/queries"
import { ParentPasscodeStep } from "../../../../../types"
import { useParentPasscodeModalStore } from "../useParentPasscodeModalStore"

const ChangePasscode = () => {
  const { user } = useUserQuery()
  const { passcode, setPasscode, setStep, showError, setShowError } =
    useParentPasscodeModalStore()
  const {
    ref: passcodeInputRef,
    focusFirstInput,
    clearInputs,
  } = useMultiInputFocus({})
  const { t } = useTranslation()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (user?.account_passcode === passcode) {
      setPasscode("")
      focusFirstInput()
      clearInputs()
      setShowError(true)
    } else {
      setShowError(false)
      setStep(ParentPasscodeStep.CONFIRM_CHANGE_PASSCODE)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4">
        <Typography variant="bodyBold">{t("PPC_SET_NEW_TITLE")}</Typography>

        <PasscodeInput
          value={passcode}
          setValue={setPasscode}
          ref={passcodeInputRef}
        />

        <Button
          text={t("PPC_NEXT")}
          type="submit"
          fullWidth
          disabled={passcode.length !== 4}
        />
        {showError && (
          <Typography variant="bodySmall" color={JoonUIColor.semantic.alert}>
            {t("PPC_ERR_DIFFERENT")}
          </Typography>
        )}
      </div>
    </form>
  )
}

export default ChangePasscode
